var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("main", { staticClass: "catalog-page page" }, [
    _c(
      "div",
      { staticClass: "page__inner" },
      [
        _c(
          "SectionComponent",
          [
            _c("BreadcrumbsComponent", { attrs: { links: _vm.breadcrumbs } }),
            _c("div", { staticClass: "page__inner" }, [
              _c("h1", [_vm._v("Каталог")]),
              _c(
                "div",
                { staticClass: "catalog-page__groups" },
                _vm._l(_vm.groups, function (item, i) {
                  return _c("GroupCard", { key: i, attrs: { data: item } })
                }),
                1
              ),
              _c(
                "div",
                { staticClass: "catalog-page__groups" },
                _vm._l(_vm.categories, function (item, i) {
                  return _c("CategoryCard", { key: i, attrs: { data: item } })
                }),
                1
              ),
            ]),
          ],
          1
        ),
        _c("ForAutoBlock", { attrs: { data: _vm.brands } }),
        _c("SectionComponent", [
          _c(
            "div",
            { staticClass: "page__inner" },
            [
              _vm.desktop
                ? _c("WrapperComponent", { attrs: { title: "Услуги" } }, [
                    _c(
                      "div",
                      { staticClass: "catalog-page__groups" },
                      [
                        _vm._l(_vm.services, function (item, i) {
                          return _c("ServiceCard", {
                            key: i,
                            attrs: { data: item },
                          })
                        }),
                        _vm.desktop
                          ? _c(
                              "div",
                              {
                                staticClass: "catalog-page__question",
                                on: { click: _vm.openModal },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "catalog-page__question-title",
                                  },
                                  [_vm._v("Не нашли то, что нужно?")]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "catalog-page__question-subtitle",
                                  },
                                  [
                                    _vm._v(
                                      "Мы решаем все вопросы, касающиеся автомобильной электроники и гаджетов."
                                    ),
                                  ]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "catalog-page__question-subtitle",
                                  },
                                  [
                                    _vm._v(
                                      "\n                Оставить заявку\n                "
                                    ),
                                    _c("IconComponent", {
                                      attrs: { name: "arrow-right" },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
              _vm.mobile
                ? _c("SliderComponent", {
                    attrs: {
                      title: "Услуги",
                      items: _vm.services,
                      "slider-options": _vm.servicesSliderOption,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ item }) {
                            return [
                              _c("ServiceCard", { attrs: { data: item } }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2126123004
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm.mobile
          ? _c(
              "div",
              {
                staticClass: "catalog-page__question",
                on: { click: _vm.openModal },
              },
              [
                _c("span", { staticClass: "catalog-page__question-title" }, [
                  _vm._v("Не нашли то, что нужно?"),
                ]),
                _c("span", { staticClass: "catalog-page__question-subtitle" }, [
                  _vm._v(
                    "Мы решаем все вопросы, касающиеся автомобильной электроники и гаджетов."
                  ),
                ]),
                _c(
                  "span",
                  { staticClass: "catalog-page__question-subtitle" },
                  [
                    _vm._v("\n        Оставить заявку\n        "),
                    _c("IconComponent", { attrs: { name: "arrow-right" } }),
                  ],
                  1
                ),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }